document.addEventListener("DOMContentLoaded", function (event) {
  let cartForm = document.querySelector('form[action="/cart"]');
  let cartBtn = document.querySelector('.quick-cart__checkout-button');
  if(cartForm) {
    cartForm.addEventListener('submit', function(e) {
      var termsCheckbox = document.getElementById('terms-checkbox');
      if (termsCheckbox && !termsCheckbox.checked) {
          e.preventDefault();
          termsCheckbox.parentNode.classList.add('not-selected');
      }
    });
  }
  if(cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      var termsCheckbox = document.getElementById('terms-checkbox');
      if (termsCheckbox && !termsCheckbox.checked) {
          e.preventDefault();
          termsCheckbox.parentNode.classList.add('not-selected');
      }
    });
  }
  
   const currentUrl = window.location.href;

  const containsProducts = currentUrl.includes("products");
  if (containsProducts) {
    const productThumbnails = document.querySelector(
      ".product-thumbnails__list"
    );
    if (productThumbnails) {
      const images = document.querySelectorAll(".product-thumbnails__item");
      const lightbox = document.querySelector("[data-lightbox]");
      images.forEach((element, index) => {
        element.addEventListener("click", function () {
          const image = element.querySelector("[data-thumbnail-id]");
          const imageId = image.getAttribute("data-thumbnail-id");
          lightbox.classList.add("active", "visible");
          const slideImageOptions = document.querySelector(
            "div.lightbox__image-nav-inner"
          );
          const buttonImage = slideImageOptions.querySelector(
            `button[data-image-index="${imageId}"]`
          );
          buttonImage.click();
        });
      });
    }
  } 
});

function updateLeadTimeVisibility() {
  const leadTime = document.querySelector('[data-lead-time] span');
  const inventoryCounter = document.querySelector('.product-extra-informations__wrapper .inventory-counter');

  if (leadTime) {
    if (inventoryCounter && inventoryCounter.classList.contains('inventory--low')) {
      leadTime.classList.add('hide');
    } else {
      leadTime.classList.remove('hide');
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(updateLeadTimeVisibility, 800);
});

document.addEventListener("flu:product:variant-change", function () {
  setTimeout(updateLeadTimeVisibility, 100);
});
